/*! PawLab shop-by-category — cards only, full-bleed row */
(function () {
  var GUTTER_MOBILE = "0.85rem";
  var GUTTER_DESKTOP = "clamp(0.5rem, 1vw, 1rem)";
  var GAP_COL_DESKTOP = "28px";
  var GAP_COL_MOBILE = "14px";
  var GAP_ROW = "0.5rem";
  var COLS_DESKTOP = "7";
  var COLS_MOBILE = "3";
  var CARD_DESKTOP = "calc((100% - 6 * 28px) / 7)";
  var CARD_MOBILE = "calc((100% - 2 * 14px) / 3)";

  function layoutWidth() {
    var client = document.documentElement ? document.documentElement.clientWidth : 0;
    return client || window.innerWidth || 0;
  }

  function isDesktop() {
    return layoutWidth() >= 750;
  }

  function cols() {
    return isDesktop() ? COLS_DESKTOP : COLS_MOBILE;
  }

  function card() {
    return isDesktop() ? CARD_DESKTOP : CARD_MOBILE;
  }

  function gapCol() {
    return isDesktop() ? GAP_COL_DESKTOP : GAP_COL_MOBILE;
  }

  /* Tile width, the 1:1 image box, and the full-page track are CSS.
     layout: full-page-width. Do not write slide widths from script —
     that paints the row small and then jumps it after load. */

  function gutter() {
    return isDesktop() ? GUTTER_DESKTOP : GUTTER_MOBILE;
  }

  function hideHeading(root) {
    if (!root) return;
    function remove(el) {
      if (el && el.parentNode) el.parentNode.removeChild(el);
    }
    root.querySelectorAll(".section-resource-list__content > .group-block").forEach(remove);
    root.querySelectorAll(".section-resource-list__content .text-block, .section-resource-list__content rte-formatter, .section-resource-list__content h1, .section-resource-list__content h2").forEach(function (el) {
      if (el.closest(".collection-card")) return;
      var t = (el.textContent || "").replace(/\s+/g, " ").trim();
      if (!t) {
        if (!el.closest(".collection-card")) remove(el.closest(".group-block") || el);
        return;
      }
      if (
        /^(Discover|DISCOVER|探索)$/i.test(t) ||
        /Shop by Categor+y|按類別選購|探索產品類別/.test(t)
      ) {
        remove(el.closest(".group-block") || el);
      }
    });
  }

  function paintSectionInterior(root) {
    if (!root) return;
    var stone = "#f3efe9";
    var nodes = root.querySelectorAll(".section-background, .section");
    nodes.forEach(function (el) {
      if (el.closest(".slideshow-control")) return;
      el.style.setProperty("background", stone, "important");
      el.style.setProperty("background-color", stone, "important");
      el.style.setProperty("--color-background", stone, "important");
      el.style.setProperty("--color-background-rgb", "243 239 233", "important");
    });
    var style = document.getElementById("pawlab-shop-category-stone");
    if (!style) {
      style = document.createElement("style");
      style.id = "pawlab-shop-category-stone";
    }
    style.textContent =
      '[id*="__collection_list_shopCategory"] > .section-background,' +
      '[id*="__collection_list_shopCategory"] > .section{' +
      "background:#f3efe9 !important;background-color:#f3efe9 !important;" +
      "--color-background:#f3efe9 !important;--color-background-rgb:243 239 233 !important}";
    document.documentElement.appendChild(style);
  }

  function alignLayout(root) {
    if (!root) return;
    var pad = gutter();
    root.style.setProperty("--page-margin", "0px", "important");
    root.style.setProperty("--full-page-grid-margin", "0px", "important");
    root.style.setProperty("--pawlab-home-gutter", pad, "important");
    root.style.setProperty("--pawlab-home-max", "none", "important");
    var colGap = gapCol();
    root.style.setProperty("--pawlab-home-gap-col", colGap, "important");
    root.style.setProperty("--pawlab-home-gap-row", GAP_ROW, "important");
    root.style.setProperty("--pawlab-story-stone", "#f3efe9", "important");
    root.style.setProperty("--pawlab-page-bg", "#f3efe9", "important");
    root.style.setProperty("--pawlab-cat-cols", cols(), "important");
    root.style.setProperty("--pawlab-cat-card", card(), "important");
    root.style.setProperty("--column-count", cols(), "important");
    root.style.setProperty("--peek-next-slide-size", "0px", "important");
    root.style.setProperty("--slide-width-max", card(), "important");
    if (!isDesktop()) {
      root.style.setProperty("--column-count-mobile", COLS_MOBILE, "important");
      root.style.setProperty("--mobile-card-size", CARD_MOBILE, "important");
    }

    var section = root.querySelector(".section");
    if (section) {
      section.classList.remove("section--page-width");
      section.classList.add("section--full-width");
      section.style.setProperty("--page-margin", "0px", "important");
      section.style.setProperty("max-width", "none", "important");
      section.style.setProperty("width", "100%", "important");
      section.style.setProperty("margin-left", "0px", "important");
      section.style.setProperty("margin-right", "0px", "important");
      section.style.setProperty("padding-left", pad, "important");
      section.style.setProperty("padding-right", "0px", "important");
      section.style.setProperty("box-sizing", "border-box", "important");
    }
    /* Horizon paints the section interior on .section-background (absolute, inset 0,
       z-index -1). .section itself is background:transparent. Inline important
       beats the color-scheme background and any later #fff / #f3efe9 stylesheet. */
    paintSectionInterior(root);

    root.querySelectorAll(
      ".section-resource-list__content, .resource-list, .resource-list--grid, .resource-list__carousel, slideshow-component, slideshow-slides, slideshow-container"
    ).forEach(function (el) {
      el.style.setProperty("--page-margin", "0px", "important");
      el.style.setProperty("--column-count", cols(), "important");
      el.style.setProperty("--peek-next-slide-size", "0px", "important");
      el.style.setProperty("--slide-width-max", card(), "important");
      if (!isDesktop()) {
        el.style.setProperty("--column-count-mobile", COLS_MOBILE, "important");
        el.style.setProperty("--mobile-card-size", CARD_MOBILE, "important");
      }
      el.style.setProperty("max-width", "none", "important");
      el.style.setProperty("width", "100%", "important");
      el.style.setProperty("margin-left", "0px", "important");
      el.style.setProperty("margin-right", "0px", "important");
      el.style.setProperty("padding-left", "0px", "important");
      el.style.setProperty("padding-right", "0px", "important");
      el.style.setProperty("box-sizing", "border-box", "important");
      if (el.classList.contains("resource-list") || el.classList.contains("resource-list--grid")) {
        el.style.setProperty("column-gap", colGap, "important");
        el.style.setProperty("row-gap", GAP_ROW, "important");
        el.style.setProperty("gap", GAP_ROW + " " + colGap, "important");
      }
    });
  }

  function fixCards(root) {
    if (!root) return;
    root.querySelectorAll(".collection-card").forEach(function (card) {
      card.style.setProperty("--ratio", "auto", "important");
      card.style.setProperty("aspect-ratio", "auto", "important");
      card.style.setProperty("height", "auto", "important");
      var inner = card.querySelector(".collection-card__inner");
      if (inner) {
        inner.style.setProperty("position", "relative", "important");
        inner.style.setProperty("inset", "auto", "important");
        inner.style.setProperty("height", "auto", "important");
        inner.style.setProperty("aspect-ratio", "auto", "important");
        inner.style.setProperty("--ratio", "auto", "important");
      }
      var imgBox = card.querySelector(".resource-image");
      if (imgBox) {
        imgBox.style.setProperty("--ratio", "1 / 1", "important");
        imgBox.style.setProperty("aspect-ratio", "1 / 1", "important");
        imgBox.style.setProperty("width", "100%", "important");
        imgBox.style.setProperty("height", "auto", "important");
        imgBox.style.setProperty("margin-bottom", "0.4rem", "important");
        imgBox.style.setProperty("background", "transparent", "important");
      }
      card.querySelectorAll("style").forEach(function (st) {
        if (st.textContent && st.textContent.indexOf("--ratio") !== -1) {
          st.textContent = st.textContent.replace(/--ratio\s*:\s*1\s*\/\s*1/g, "--ratio: auto");
        }
      });
    });
  }

  function run() {
    var root = document.querySelector('[id*="__collection_list_shopCategory"]');
    if (!root) return;
    hideHeading(root);
    alignLayout(root);
    fixCards(root);
  }

  run();
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  window.addEventListener("load", run);
  window.addEventListener("resize", run, { passive: true });
  setTimeout(run, 50);
  setTimeout(run, 250);
  setTimeout(run, 800);
  setTimeout(run, 1600);
  setTimeout(run, 2800);
})();
